import React, {
  createContext,
} from "react";

// type ProductConfigType = "frames" | "lenses" | "rx";
type ColorSchemeType = "group" | "color";

interface IProductColorScheme{
   [key:string] : Record<ColorSchemeType, string>;
}

export const ProductConfigContext = createContext<IProductColorScheme>({} as IProductColorScheme);